import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_MS = 30 * 60 * 1000;

export const getVisitorId = () => {
  let id = localStorage.getItem("mx_visitor");
  if (!id) {
    id = window.crypto?.randomUUID ? window.crypto.randomUUID() : `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("mx_visitor", id);
  }
  return id;
};

// Rolling 30-min session. Returns { id, isNew }.
export const getSession = () => {
  let s = null;
  try { s = JSON.parse(localStorage.getItem("mx_session")); } catch {}
  const now = Date.now();
  let isNew = false;
  if (!s || !s.id || now > s.exp) {
    s = { id: window.crypto?.randomUUID ? window.crypto.randomUUID() : `s-${now}-${Math.random().toString(36).slice(2)}` };
    isNew = true;
  }
  s.exp = now + SESSION_MS;
  localStorage.setItem("mx_session", JSON.stringify(s));
  return { id: s.id, isNew };
};

const parseTouch = () => {
  const p = new URLSearchParams(window.location.search);
  return {
    source: p.get("utm_source") || "", medium: p.get("utm_medium") || "",
    campaign: p.get("utm_campaign") || "", ref: p.get("ref") || "",
    referrer: document.referrer || "", landing: window.location.pathname,
    at: new Date().toISOString(),
  };
};

// First touch is stored once and never overwritten; last touch always updates.
export const captureTouch = () => {
  const t = parseTouch();
  const has = t.source || t.medium || t.campaign || t.ref || t.referrer;
  if (has) {
    if (!localStorage.getItem("mx_touch_first")) localStorage.setItem("mx_touch_first", JSON.stringify(t));
    localStorage.setItem("mx_touch_last", JSON.stringify(t));
  }
  return t;
};

export const lastTouch = () => {
  try { return JSON.parse(localStorage.getItem("mx_touch_last")) || {}; } catch { return {}; }
};

export const trackEvent = (type, meta = {}) => {
  try {
    const t = lastTouch();
    axios.post(`${API}/track/event`, {
      type, visitor_id: getVisitorId(), session_id: getSession().id,
      path: window.location.pathname, referrer: document.referrer || "",
      meta, utm: { source: t.source || "", medium: t.medium || "", campaign: t.campaign || "" },
    }).catch(() => {});
  } catch {}
};
